module.exports = __webpack_public_path__ + "img/evaluation-2016-award.3af40e97.jpg";